var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAntennaLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M30,53.1c-1.1,0-2-0.9-2-2V11c0-1.1,0.9-2,2-2s2,0.9,2,2v40.1C32,52.2,31.1,53.1,30,53.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M30,33.8c-0.7,0-1.3-0.3-1.7-0.9L15.1,12.1c-0.6-0.9-0.3-2.2,0.6-2.8c0.9-0.6,2.2-0.3,2.8,0.6l13.2,20.8 c0.6,0.9,0.3,2.2-0.6,2.8C30.7,33.7,30.4,33.8,30,33.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M30,33.8c-0.4,0-0.7-0.1-1.1-0.3c-0.9-0.6-1.2-1.8-0.6-2.8L41.5,9.9c0.6-0.9,1.8-1.2,2.8-0.6 s1.2,1.8,0.6,2.8L31.7,32.9C31.3,33.5,30.7,33.8,30,33.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAntennaLight);
export default __webpack_public_path__ + "static/media/device-antenna-light.4ea8f48082bb55f9f8cb66dbfc206e66.svg";
export { ForwardRef as ReactComponent };